import pgrid from 'projection-grid';
import _ from 'underscore';
import { PageReady } from '@bingads-webui/page-ready';

const { version } = pgrid;

// Only log the navigation timing info for first grid data load for Grid performance measurement
// during page load.
let isInitialGridDataLoad = true;
let isPageReadyFulfilled = false;

PageReady.afterPageReady().then(() => {
  isPageReadyFulfilled = true;
});

function logPerformanceInfo({
  name,
  gridView,
  virtualized,
  logNavTiming = false,
  track,
  marker,
  appConfig,
  parentMarker,
}) {
  const { id } = track;
  marker.willFetchData();
  if (parentMarker) {
    parentMarker.willFetchData();
  }

  gridView.once('didReload', (isSuccess) => {
    if (isSuccess && id === track.id) {
      marker.willRender();
      if (parentMarker) {
        parentMarker.willRender();
      }

      gridView.once('didRedraw', () => {
        if (id === track.id) {
          marker.done(JSON.stringify(_.defaults({
            Version: `projection-grid@${version}`,
            GridName: name,
            IsPageReadyFulfilled: isPageReadyFulfilled,
            IsVirtualized: virtualized,
            TotalRows: gridView.countRows,
            TotalServerSideRows: gridView.totalCountRows,
            // For the visible rows, do not count the tr.top-filler and tr.bottom-filler
            TotalVisibleRows: gridView.$('tbody > tr:visible').length - 2,
            TotalColumns: gridView.$('table').last().find('colgroup > col').length,
          }, logNavTiming ? { // Add navigation timing info to indicate this is first Grid load
            PageNavStartTime: performance.timing.navigationStart,
            PageFetchStartTime: performance.timing.fetchStart,
            LandingPageUrl: appConfig.get('LandingPageUrl') || '',
          } : {})));
        }
      });
    }
  });
}

export const perfMarkerPlugin = definePlugin => definePlugin('perfMarker', [
  'config',
  'gridView',
], ({
  scrolling: {
    virtualized = false,
  } = {},
  name,
  plugins,
} = {}, gridView) => {
  const track = {};
  const { appConfig, marker, gridMarker } = plugins.perfMarker;

  if (!marker && !gridMarker) {
    return;
  }

  let pgridMarker = null;

  // If grid has passed a marker then use it.
  // Grid component has to call 'willInit'.
  if (gridMarker) {
    pgridMarker = gridMarker;
  } else {
    pgridMarker = marker.createChild(`pgrid-${name}-load`);
    pgridMarker.willInit();
  }

  gridView.on('willReload', () => {
    track.id = _.uniqueId('log-track-');

    // If grid marker is already marked done
    // then it means this grid load is from some action on grid
    // actions like, sort, filter, column selection etc.
    // Create a new marker under parent in that case to capture user action.
    if (pgridMarker && pgridMarker.isDone === true && pgridMarker.parentMarker) {
      pgridMarker = pgridMarker.parentMarker.createChild(`pgrid-${name}-action`);
      pgridMarker.willInit();
    }

    logPerformanceInfo({
      name,
      virtualized,
      gridView,
      logNavTiming: isInitialGridDataLoad,
      track,
      appConfig,
      marker: pgridMarker,
      parentMarker: pgridMarker.parentMarker,
    });

    isInitialGridDataLoad = false;
  });
});
